// extracted by mini-css-extract-plugin
module.exports = {"text":"Testimonial-module--text--1xC1I"};